var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00114346 7.54686C0.0118866 7.85314 0.141435 8.14501 0.36517 8.36703L6.71909 14.6158C6.96265 14.855 7.29692 14.9932 7.64835 14.9998C7.99978 15.0063 8.33958 14.8809 8.59302 14.6509C8.84645 14.421 8.99276 14.1054 8.99974 13.7736C9.00672 13.4418 8.87381 13.121 8.63025 12.8817L3.16156 7.5L8.63025 2.11828C8.87381 1.87901 9.00672 1.55819 8.99974 1.22641C8.99276 0.894618 8.84645 0.579037 8.59302 0.349088C8.33958 0.119138 7.99978 -0.00634347 7.64835 0.000247088C7.29692 0.00683765 6.96265 0.144961 6.71909 0.384231L0.36517 6.63297C0.242641 6.75445 0.147274 6.89796 0.084733 7.05497C0.022193 7.21198 -0.00624084 7.37926 0.00114346 7.54686Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.e3bcc59544e84884ed7d4b7b06cc3d98.svg";
export { ForwardRef as ReactComponent };